/* eslint-disable no-param-reassign */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useState, useEffect } from 'react';
import {
  Button,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  TextField,
  Typography,
  Paper,
  Table,
  IconButton,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
} from '@material-ui/core';
import { Delete, Edit } from '@material-ui/icons';
import skillServices from '../../../../redux/services/skillServices';
import coursePlanServices from '../../../../redux/services/coursePlanServices';

const SpecificSkills = ({
  specificSkills, setSpecificSkills, language, level, group,
}) => {
  const [skillEN, setSkillEN] = useState('');
  const [skillFR, setSkillFR] = useState('');
  const [open, setOpen] = useState(false);
  const [selectedSkill, setSelectedSkill] = useState({});
  const [coursePlan, setCoursePlan] = useState(group.coursePlan);

  useEffect(() => {
    setCoursePlan(group.coursePlan);
  }, [group]);

  const handleAddSpecificSkill = () => {
    const body = {
      EN: skillEN,
      FR: skillFR,
      level,
      type: 'specific',
    };
    skillServices.addSkill(body).then((res) => {
      const specificSkillsIdsArr = [];
      if (specificSkills !== undefined && specificSkills.length > 0) {
        const specificSkillsArr = [...specificSkills];
        specificSkillsArr.forEach((skill) => {
          specificSkillsIdsArr.push(skill._id);
        });
      }
      specificSkillsIdsArr.push(res._id);
      const newBody = {
        specificSkills: specificSkillsIdsArr,
      };
      coursePlanServices.updateCoursePlan(coursePlan._id, newBody).then((newRes) => {
        setSpecificSkills([...specificSkills, res]);
      });
    });
  };

  const handleOpenDialog = (skillId) => {
    specificSkills.forEach((skill) => {
      if (skill._id === skillId) {
        setSelectedSkill(skill);
      }
    });
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleUpdateSkill = () => {
    const body = {
      EN: selectedSkill.EN,
      FR: selectedSkill.FR,
      level,
      type: 'specific',
    };
    skillServices.updateSkill(selectedSkill._id, body).then((res) => {
      const skillsArr = [...specificSkills];
      skillsArr.forEach((skill) => {
        if (skill._id === res._id) {
          skill.EN = res.EN;
          skill.FR = res.FR;
        }
      });
      setSpecificSkills(skillsArr);
      handleClose();
    });
  };

  const handleDeleteSkill = (skillId) => {
    skillServices.deleteSpecificSkill(skillId).then((res) => {
      const coursePlanObj = { ...coursePlan };
      coursePlanObj?.specificSkills?.forEach((skill, index) => {
        if (skill._id === skillId) {
          coursePlanObj.specificSkills.splice(index, 1);
        }
      });
      const specificSkillsArr = [...specificSkills];
      specificSkillsArr.forEach((skill, index) => {
        if (skill._id === skillId) {
          specificSkillsArr.splice(index, 1);
        }
      });
      setSpecificSkills(specificSkillsArr);
      // coursePlanServices.updateCoursePlan(coursePlan._id, coursePlanObj)
      // .then((resCoursePlan) => {
      // });
    });
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
      <Typography style={{ marginTop: '50px', marginBottom: '15px' }}>Specific skills</Typography>
      <Divider style={{ marginBottom: '15px', width: '100%' }} />
      <TableContainer component={Paper} style={{ marginTop: '15px', marginBottom: '15px' }}>
        <Table style={{ minWidth: 650 }} aria-label="simple table">
          <TableBody>
            {(specificSkills !== undefined && specificSkills.length > 0)
            && specificSkills.map((specificSkill) => (
              <TableRow>
                <TableCell align="left" style={{ width: '150px' }}>
                  <IconButton onClick={() => handleOpenDialog(specificSkill._id)}>
                    <Edit color="primary" />
                  </IconButton>
                  <IconButton onClick={() => handleDeleteSkill(specificSkill._id)}>
                    <Delete color="secondary" />
                  </IconButton>
                </TableCell>
                <TableCell>
                  {specificSkill[language]}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Typography style={{ marginTop: '15px', marginBottom: '15px' }}>Add specific skills</Typography>
      <Divider style={{ marginBottom: '30px', width: '100%' }} />
      <Paper
        style={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          padding: '20px',
          width: '100%',
        }}
      >
        <TextField
          label="New skill in english"
          value={skillEN}
          variant="outlined"
          onChange={(e) => setSkillEN(e.target.value)}
          style={{
            marginBottom: '15px',
            width: '100%',
          }}
        />
        <TextField
          label="New skill in french"
          value={skillFR}
          variant="outlined"
          onChange={(e) => setSkillFR(e.target.value)}
          style={{ marginBottom: '15px', width: '100%' }}
        />
        <Button
          variant="contained"
          color="secondary"
          style={{
            backgroundColor: '#2E7D32',
            color: '#FFF',
          }}
          disableElevation
          onClick={handleAddSpecificSkill}
        >
          Add
        </Button>
      </Paper>
      <Dialog
        open={open}
        onClose={handleClose}
      >
        <DialogContent style={{ display: 'flex', flexDirection: 'column' }}>
          <TextField
            style={{ marginBottom: '15px' }}
            variant="outlined"
            value={selectedSkill.EN}
            label="Content in english"
            onChange={(e) => setSelectedSkill({ ...selectedSkill, EN: e.target.value })}
          />
          <TextField
            variant="outlined"
            value={selectedSkill.FR}
            label="Content in french"
            onChange={(e) => setSelectedSkill({ ...selectedSkill, FR: e.target.value })}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleUpdateSkill}>Confirmer</Button>
          <Button onClick={handleClose}>Annuler</Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default SpecificSkills;
